import {Component} from '@angular/core';
import {QuestionOptions} from '../../../constants/question-options';
import {FormBuilder, Validators} from '@angular/forms';
import {CustomValidators} from '../../../validator/custom-validator';
import {CompanyFormBase} from '../company-form-base/company-form-base.component';
import {Company} from '../../../model/proposal/company';

@Component({
    selector: 'app-contact-information-company-form',
    templateUrl: './contact-information-company-form.component.html',
    styleUrls: ['../../../../styles/form-input.scss'],
    providers: [{ provide: CompanyFormBase, useExisting: ContactInformationCompanyFormComponent }],
    standalone: false
})
export class ContactInformationCompanyFormComponent extends CompanyFormBase {
  QuestionOptions = QuestionOptions;

  constructor(private readonly fb: FormBuilder) {
    super();
  }

  formGroup = this.fb.group({
    telephoneNumber: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    faxNumber: [''],
    emailAddress: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    seatNumber: [''],
  });

  updateCompany(company: Company): void {
    company.telephoneNumber = this.formGroup.value.telephoneNumber;
    company.faxNumber = this.formGroup.value.faxNumber;
    company.emailAddress = this.formGroup.value.emailAddress;
    company.seatNumber = this.formGroup.value.seatNumber;
  }
}
